export default __webpack_public_path__ + "static/media/oldfemale.55f2c2c2.svg";